export default __webpack_public_path__ + "static/media/our-process-bg-2.82fa11e5.jpg";